import React, { Component } from 'react';
import styled from 'styled-components';

import { colors } from '../styles/colors';
import { devices } from '../styles/breakpoints';

const TitleWrapper = styled.p`
  display: flex;
  width: 100%;
  font-size: 20px;
  line-height: 20px;
  max-height: 28px;
  color: ${colors.BRAND_PRIMARY};
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid ${colors.GRAY};

  @media ${devices.desktop} {
    margin-top: 32px;
    font-size: 32px;
    font-weight: 300;
  }
`;

class Title extends Component {
  render() {
    const { children } = this.props;
    return <TitleWrapper>{children}</TitleWrapper>;
  }
}

export default Title;
